// assets/mobile-navbar.js
// ======================================================
// Sticky Mobile Navbar + Cart Bubble + Lottie Animation
// ======================================================

(function () {
  // ======================================================
  // Main init
  // ======================================================
  document.addEventListener('DOMContentLoaded', function () {
    const menu = document.getElementById('sticky-menu');
    const qaEnabled = menu ? (menu.getAttribute('data-qa-enabled') === 'true') : false;

    // Abre o drawer do carrinho ao tocar no item da navbar
    const cartOpenBtns = document.querySelectorAll('[data-cart-open]');
    cartOpenBtns.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        document.getElementById('cart-icon-bubble')?.click();
      });
    });

    function toggleStickyMenu() {
      const stickyMenu = document.getElementById('sticky-menu');
      if (!stickyMenu) return;

      // respeita hard-hide, se estiver ativo
      if (stickyMenu.getAttribute('data-force-hidden') === 'true') {
        stickyMenu.style.display = 'none';
        return;
      }

      stickyMenu.style.display = window.innerWidth <= 768 ? 'flex' : 'none';
    }
    toggleStickyMenu();

    // Esconde a navbar quando o menu-drawer (hamburger) está aberto
    const menuDrawer = document.getElementById('Details-menu-drawer-container');
    if (menuDrawer) {
      menuDrawer.addEventListener('toggle', function () {
        const el = document.getElementById('sticky-menu');
        if (!el) return;

        // se hard-hide está ativo, mantém escondido
        if (el.getAttribute('data-force-hidden') === 'true') {
          el.style.display = 'none';
          return;
        }

        el.style.display = menuDrawer.open ? 'none' : (window.innerWidth <= 768 ? 'flex' : 'none');
      });
    }

    // Dropdown da conta (sticky)
    const accountBtn = document.getElementById('mobile-account-button');
    const accountDropdown = document.getElementById('mobile-account-dropdown');

    if (accountBtn && accountDropdown && !window._dropdownInitialized) {
      window._dropdownInitialized = true;
      
      accountBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        const isOpen = accountBtn.getAttribute('aria-expanded') === 'true';
        accountBtn.setAttribute('aria-expanded', String(!isOpen));
        accountDropdown.classList.toggle('dropdown-hidden');
      });

      document.addEventListener('click', function (e) {
        if (!accountBtn.contains(e.target) && !accountDropdown.contains(e.target)) {
          accountBtn.setAttribute('aria-expanded', 'false');
          accountDropdown.classList.add('dropdown-hidden');
        }
      });
    }

    // === Atualização dinâmica do contador no sticky menu ===
    function updateCartBubbleNavbar(itemCount) {
      const bubble = document.querySelector('.cart-count-bubble-navbar');
      if (!bubble) return;

      const countSpan = bubble.querySelector('span[aria-hidden="true"]');

      if (itemCount > 0 && itemCount < 100) {
        bubble.style.display = 'flex';
        bubble.classList.remove('hidden');
        if (countSpan) countSpan.textContent = String(itemCount);
      } else {
        if (countSpan) countSpan.textContent = '';
        bubble.style.display = 'none';
        bubble.classList.add('hidden');
      }
    }

    // ===== Controle anti-429 para leitura do carrinho =====
    let cartBadgeInFlight = false;
    let nextAllowedAt = 0;      // timestamp mínimo para próxima consulta
    const MIN_GAP_MS = 800;     // janela mínima entre GETs ao /cart.js
    let scheduledTimer = null;  // debounce/agenda

    async function fetchCartItemCountAndUpdate() {
      const now = Date.now();
      if (cartBadgeInFlight || now < nextAllowedAt) {
        scheduleCartRefresh(Math.max(MIN_GAP_MS, nextAllowedAt - now + 50));
        return;
      }

      cartBadgeInFlight = true;

      try {
        if (!window.CartAPI || !window.CartAPI.getCart) {
          // fallback leve
          const res = await fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
          if (!res.ok) {
            if (res.status === 429) nextAllowedAt = Date.now() + 2000;
            return;
          }
          const cart = await res.json();
          if (cart && typeof cart.item_count === 'number') {
            updateCartBubbleNavbar(cart.item_count);
          }
          nextAllowedAt = Date.now() + MIN_GAP_MS;
          return;
        }

        const { ok, status, data } = await window.CartAPI.getCart();
        if (!ok) {
          if (status === 429) nextAllowedAt = Date.now() + 2000; // respeita backoff
          return;
        }
        if (data && typeof data.item_count === 'number') {
          updateCartBubbleNavbar(data.item_count);
        }
        nextAllowedAt = Date.now() + MIN_GAP_MS;
      } catch (e) {
        // silêncio
      } finally {
        cartBadgeInFlight = false;
      }
    }

    function scheduleCartRefresh(delayMs = MIN_GAP_MS) {
      if (scheduledTimer) {
        clearTimeout(scheduledTimer);
        scheduledTimer = null;
      }
      scheduledTimer = setTimeout(() => {
        scheduledTimer = null;
        fetchCartItemCountAndUpdate();
      }, delayMs);
    }

    // Eventos que disparam atualização (coalescidos pelo throttle/debounce acima)
    if (typeof subscribe === 'function') {
      subscribe('cart-update', () => {
        scheduleCartRefresh(150); // pequeno atraso pra garantir sections atualizadas
      });
    }
    window.addEventListener('cart-update', () => {
      scheduleCartRefresh(150);
    });

    // Escuta eventos modernos emitidos pelo cart-drawer.js e cart-discount.js
    document.addEventListener('cart-drawer:updated', () => {
      scheduleCartRefresh(150);
    });

    document.addEventListener('cart:updated', (event) => {
      // Se o evento já trouxer o objeto cart, usamos direto para evitar fetch
      if (event.detail && event.detail.cart && typeof event.detail.cart.item_count === 'number') {
        updateCartBubbleNavbar(event.detail.cart.item_count);
      } else {
        scheduleCartRefresh(150);
      }
    });

    // Atualiza uma vez ao carregar
    fetchCartItemCountAndUpdate();

    // Atualização após submit do product form (sem interceptar fetch global)
    const productForm = document.querySelector('product-form form[action="/cart/add"]');
    if (productForm) {
      productForm.addEventListener('submit', () => {
        scheduleCartRefresh(500);
        // playCartAddAnimation();
      });
    }

    // Intercepta adições ao carrinho para garantir animação do ícone
    try {
      if (!window._mobileNavbarPatched) {
        const _fetch = window.fetch;
        window.fetch = async function (input, init) {
          const url = typeof input === 'string' ? input : (input?.url || '');
          const method = (init?.method || '').toUpperCase();
          const isAdd = method === 'POST' && /\/cart\/add(\.js)?(\?|$)/.test(url);

          const resp = await _fetch.apply(this, arguments);

          if (isAdd && resp && resp.ok) {
            try { window.dispatchEvent(new CustomEvent('cart:item-added')); } catch (_) {}
            scheduleCartRefresh(150);
          }
          return resp;
        };
        window._mobileNavbarPatched = true;
      }
    } catch (_) {}

    // ===== Fix iOS: respeitar barras do navegador, mas ignorar pull-to-refresh =====
    (function () {
      const stickyMenu = document.getElementById('sticky-menu');
      if (!stickyMenu || !window.visualViewport) return;

      const vv = window.visualViewport;
      let lastGap = 0;

      function isKeyboardOpen() {
        const ae = document.activeElement;
        const editable =
          ae &&
          (ae.isContentEditable ||
            ae.tagName === 'INPUT' ||
            ae.tagName === 'TEXTAREA' ||
            ae.tagName === 'SELECT');

        const delta = window.innerHeight - vv.height;
        return !!editable && delta > 80;
      }

      function isPullToRefreshOrRubberBand() {
        // no iOS, quando "puxa" o topo (overscroll), o body desce (top > 0)
        const bodyTop = document.body.getBoundingClientRect().top;
        return bodyTop > 0;
      }

      function computeBottomGap() {
        // gap entre layout viewport e visual viewport (barras do navegador/keyboard)
        let gap = Math.max(0, window.innerHeight - (vv.height + vv.offsetTop));
        // corta spikes absurdos
        gap = Math.min(gap, 200);
        return gap;
      }

      function apply() {
        // ✅ durante pull-to-refresh: não deixa a navbar "subir" loucamente
        if (isPullToRefreshOrRubberBand()) {
          lastGap = 0;
          document.documentElement.style.setProperty('--sticky-vv-bottom', '0px');
          return;
        }

        // teclado aberto: usa gap real
        if (isKeyboardOpen()) {
          const gap = computeBottomGap();
          lastGap = gap;
          document.documentElement.style.setProperty('--sticky-vv-bottom', gap + 'px');
          return;
        }

        // ✅ sem teclado: usa o gap pra não cobrir a barra do navegador quando ela aparece
        const gap = computeBottomGap();

        // suaviza variações pequenas pra evitar tremedeira
        const smoothed = Math.abs(gap - lastGap) > 40
          ? gap
          : Math.round((lastGap * 0.6) + (gap * 0.4));

        lastGap = smoothed;
        document.documentElement.style.setProperty('--sticky-vv-bottom', smoothed + 'px');
      }

      apply();
      vv.addEventListener('resize', apply);
      vv.addEventListener('scroll', apply);
      window.addEventListener('scroll', apply, { passive: true });
      window.addEventListener('orientationchange', () => setTimeout(apply, 50));
      window.addEventListener('focusin', apply);
      window.addEventListener('focusout', apply);

      // fallback: quando termina o gesto, garante reset rápido
      window.addEventListener('touchend', () => setTimeout(apply, 0), { passive: true });
    })();
  });

  // ======================================================
  // Resize handler (mantém / respeita hard-hide)
  // ======================================================
  window.addEventListener('resize', function () {
    const stickyMenu = document.getElementById('sticky-menu');
    if (!stickyMenu) return;

    // respeita hard-hide
    if (stickyMenu.getAttribute('data-force-hidden') === 'true') {
      stickyMenu.style.display = 'none';
      return;
    }

    stickyMenu.style.display = window.innerWidth <= 768 ? 'flex' : 'none';
  });

  // ======================================================
  // Cart icon Lottie animation
  // ======================================================
  let isAnimatingCartIcon = false;

  function playCartAddAnimation(targetEl) {
    // Prioriza o wrapper do sticky menu; cai no header apenas como fallback
    const wrapper =
      targetEl ||
      document.querySelector('#sticky-menu [data-cart-open] #cart-icon-wrapper') || // navbar mobile
      document.querySelector('header [data-cart-open] #cart-icon-wrapper') ||       // header (fallback)
      document.querySelector('#cart-icon-wrapper');                                 // fallback genérico

    if (!wrapper || isAnimatingCartIcon) return;

    isAnimatingCartIcon = true;

    const originalHTML = wrapper.innerHTML;
    const lottieURL    = wrapper.getAttribute('data-lottie-url') || '';
    const lottieWidth  = wrapper.getAttribute('data-lottie-width') || '42px';
    const lottieHeight = wrapper.getAttribute('data-lottie-height') || '42px';

    const lottie = document.createElement('lottie-player');
    lottie.setAttribute('src', lottieURL);
    lottie.setAttribute('background', 'transparent');
    lottie.setAttribute('speed', '1');
    lottie.setAttribute('style', `width:${lottieWidth};height:${lottieHeight};display:inline-block;vertical-align:middle;`);
    lottie.setAttribute('autoplay', '');

    wrapper.innerHTML = '';
    wrapper.appendChild(lottie);

    const restore = () => {
      wrapper.innerHTML = originalHTML;
      isAnimatingCartIcon = false;
    };

    lottie.addEventListener('complete', restore);

    setTimeout(() => {
      if (isAnimatingCartIcon) restore();
    }, 3000);
  }

  window.playCartAddAnimation = playCartAddAnimation;

  // toca a animação quando um item for adicionado via fluxo dos cards
  window.addEventListener('cart:item-added', () => playCartAddAnimation());

  // Mantém compatibilidade se você usa 'cart-update' como gatilho genérico:
  window.addEventListener('cart-update', () => {
    const bubble = document.querySelector('.cart-count-bubble-navbar span[aria-hidden="true"]');
    const count = bubble ? parseInt(bubble.textContent || '0', 10) : 0;
    if (count > 0) playCartAddAnimation();
  });

  /* ============================
     HARD-HIDE CONTROLLER (sem flicker)
     ============================ */
  (function () {
    const MOBILE_MAX = 768;

    const stickyMenu = document.getElementById('sticky-menu');
    const qaSticky   = document.getElementById('qa-sticky'); // botão flutuante "Adicionar"
    const qaModal    = document.getElementById('qa-modal');

    if (!stickyMenu) return;

    const qaEnabledLocal = stickyMenu.getAttribute('data-qa-enabled') === 'true';

    const ADD_BUTTON_SELECTOR = [
      'button.product-form__submit[name="add"]',
      'button[name="add"].product-form__submit',
      'button[id^="ProductSubmitButton"]'
    ].join(',');

    function hasPassedAddButton() {
      const form = document.querySelector('product-form form[action="/cart/add"]') ||
                   document.querySelector('form[action="/cart/add"]');

      const btn = (form && (form.querySelector(ADD_BUTTON_SELECTOR) || form.querySelector('.product-form__buttons'))) ||
                  document.querySelector(ADD_BUTTON_SELECTOR) ||
                  document.querySelector('.product-form__buttons');

      if (!btn) return false;
      const r = btn.getBoundingClientRect();
      return r.bottom < 0;
    }

    function shouldHideMobileNavbar() {
      const isMobile = window.innerWidth <= MOBILE_MAX;
      if (!isMobile) return false;
      if (!qaEnabledLocal) return false;

      const stickyVisible = !!qaSticky && qaSticky.hidden === false;
      const modalOpen     = !!qaModal  && qaModal.hidden === false;
      const passedBtn     = hasPassedAddButton();

      return passedBtn || stickyVisible || modalOpen;
    }

    function applyStickyMenuVisibilityHard() {
      const hide = shouldHideMobileNavbar();
      stickyMenu.setAttribute('data-force-hidden', hide ? 'true' : 'false');

      if (hide) {
        stickyMenu.style.display = 'none';
      } else {
        stickyMenu.style.display = (window.innerWidth <= MOBILE_MAX) ? 'flex' : 'none';
      }
    }

    let rafId = null;
    function scheduleApply() {
      if (rafId) return;
      rafId = requestAnimationFrame(() => {
        rafId = null;
        applyStickyMenuVisibilityHard();
      });
    }

    const atcTarget = document.querySelector(ADD_BUTTON_SELECTOR) ||
                      document.querySelector('.product-form__buttons');

    if ('IntersectionObserver' in window && atcTarget) {
      const io = new IntersectionObserver(() => {
        scheduleApply();
      }, { threshold: [0, 1] });
      io.observe(atcTarget);
    }

    window.addEventListener('scroll', scheduleApply, { passive: true });
    window.addEventListener('resize', scheduleApply, { passive: true });
    window.addEventListener('cart-update', scheduleApply);
    window.addEventListener('qa-visibility-change', scheduleApply);

    applyStickyMenuVisibilityHard();
  })();
})();

// ===== Fase 1 · esconde a navbar ao rolar para baixo, mostra ao rolar para cima =====
(function () {
  var lastY = window.scrollY, ticking = false;
  function onScroll() {
    var menu = document.getElementById('sticky-menu');
    if (!menu) return;
    var y = window.scrollY, delta = y - lastY;
    if (Math.abs(delta) > 8) {
      var nearBottom = (window.innerHeight + y) >= (document.documentElement.scrollHeight - 80);
      menu.classList.toggle('is-scrolled-away', delta > 0 && y > 120 && !nearBottom);
      lastY = y;
    }
    ticking = false;
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { window.requestAnimationFrame(onScroll); ticking = true; }
  }, { passive: true });
})();
